const reseted = {teamData: null};

export default (state, targetId) => {
	const newState = state.map((scope) => {
		if (scope.id === targetId) {
			return {...scope, ...reseted};
		}
		if (scope.subScopes.some((subScope) => subScope.id === targetId)) {
			const newSubScopes = scope.subScopes.map((subScope) => {
				if (subScope.id === targetId) {
					return {...subScope, ...reseted};
				}
				return subScope;
			});
			return {...scope, subScopes: newSubScopes};
		}
		return scope;
	});

	return newState;
};
